import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { ENV_VARIABLES } from 'src/common/constants';

// Both values are set by mcc-admin-dashboard's staging deploy workflows -
// 'staging' by the normal ones, 'staging-pointing-to-prod' only by
// deploy-staging-with-prod-config.yml - so this banner also flags the
// less obvious case of staging serving a build wired to prod's API.
const BANNER_LABELS: Record<string, string> = {
  staging: 'STAGING',
  'staging-pointing-to-prod': 'STAGING — POINTS TO PROD',
};

export function StagingBanner() {
  const [isDismissed, setIsDismissed] = useState(false);
  const label =
    ENV_VARIABLES.APP_ENVIRONMENT &&
    BANNER_LABELS[ENV_VARIABLES.APP_ENVIRONMENT];

  if (!label || isDismissed) {
    return null;
  }

  return (
    <div className="flex w-full items-center justify-center gap-2 bg-amber-400 px-4 py-1 text-sm font-semibold text-black">
      <span>{label}</span>
      {ENV_VARIABLES.GIT_REF && (
        <span className="font-mono text-xs font-normal">
          {ENV_VARIABLES.GIT_REF}
          {ENV_VARIABLES.GIT_COMMIT &&
            `@${ENV_VARIABLES.GIT_COMMIT.slice(0, 7)}`}
        </span>
      )}
      <button
        aria-label="Dismiss staging banner"
        className="ml-2 flex items-center"
        onClick={() => setIsDismissed(true)}
        type="button"
      >
        <CloseIcon fontSize="small" />
      </button>
    </div>
  );
}
